import React, {Component} from 'react'
import {Link, location} from 'react-router-dom'
import { withRouter } from "react-router";
import {Card, CardBody, Button, Progress, CardTitle, Row, Col} from 'reactstrap';
import { Uploader, UploadField } from '@navjobs/upload'
import MainInfo from '../MainInfo'
import Report from '../Report'
import StdButton from '../StdButton'
import { Trans } from "react-i18next";
import StdTable from '../StdTable'
import Invoices from '../Invoices'
import IssuingCompaniesInfo from '../IssuingCompaniesInfo'
import actionCable from "actioncable"
class Companies extends Component{


  constructor(props){
	  super(props);
  }
  
  componentDidMount(){

    const {getCompany, match: {params: {id: id}}} = this.props
    getCompany(id)    
    let consumer=actionCable.createConsumer('/cable')
    this.channel = consumer.subscriptions.create({ channel: "CompanyChannel", company_id: id }, {
      received(data) {
        getCompany(id)
      }      
    })
  }
  
  componentWillUnmount() {
    this.channel.unsubscribe();
  }

  render(){

	  const {company, createReport, getCompany, uploadError, updateReport} = this.props
	  const downloadable_reports = company && company.reports ? company.reports.filter(r => r.product&&['VISURA_PDF', 'VISURA_STORICA_PDF', 'BILANCIO_PDF'].includes(r.product.name) ) : []
	  if(company){

	    return (
		    <div>
		      <Card>
			      <CardBody>			    
			        <h1 className="display-4">{company.name}</h1>
			        <Link to={`/api/companies/${company.id}.pdf`} target="_new"  className="btn btn-primary pull-right no-print"><i className="fas fa-file-pdf"></i> Scarica in pdf</Link>
			      </CardBody>
		      </Card>

		      <Card>
			      <CardBody>
			        <CardTitle><h2><Trans>companies.sections.main_info</Trans></h2></CardTitle>
			        <MainInfo main_info={company} />	    
			      </CardBody>
		      </Card>

		      <Card>
			      <CardBody>
			        <IssuingCompaniesInfo infos={company.invoices_info} issuing_companies={company.issuing_companies} />
			      </CardBody>
		      </Card>

		      <Card>
			      <CardBody>
			        <IssuingCompaniesInfo infos={company.issuing_companies_info} issuing_companies={company.issuing_companies} type="ISSUING_COMPANIES" />
			        
			      </CardBody>
		      </Card>

		      
		      <Invoices invoices={company.invoices} />		      
		      

		      <Card className="no-print">
			      <CardBody>
			        <CardTitle><h2><Trans>companies.sections.products</Trans></h2></CardTitle>
			        { company.products.map(p =>
                <StdButton buttonProps={{className:"action_button"}} buttonAction={() => createReport(company.id, p.name, p.parameters)} confirmation={`Il costo del report è di ${Math.round(p.price)} crediti`}>
				          <i className={p.downloadable ? 'fa fa-file-pdf' : 'fa fa-box' }></i>
				          <h4><Trans>{p.title}</Trans></h4>
				        </StdButton>
              ) }
              
	            
			        
			        <Link to="/template.xls" target="_blank" className="action_button btn" download>
				        <i className="fas fa-download"></i>
				        <h4><Trans>companies.actions.download_template</Trans></h4>
			        </Link>
			        
			        <div className="uploadField btn" style={{padding: 0}}>
				        <Uploader request={{
				          fileName: 'uploadedFile',
				          url: `/api/companies/${company.id}/reports?report_type=EXCEL`,
				          method: 'POST',
				          headers: {
					          'X-CSRF-TOKEN': document.querySelector('[name=csrf-token]').content,
				          }
				        }}
					                onComplete={({ response, status }) => {
					                  
					                  getCompany(this.props.match.params.id)
					                }}
					                onError={(props) => {
					                  uploadError({error_code: 'INVALID_XLS'})
					                }}
					                uploadOnSelection={true}
				        >
				          
				          {({ onFiles, progress, complete }) => (
					          <div>
					            <UploadField onFiles={onFiles} uploadProps={{
						            accept: '.xls,.xlsx',
					            }}> 
						            
						            <StdButton buttonProps={{className:"action_button btn"}}>
						              <i className="far fa-file-excel"></i>
						              <h4><Trans>companies.actions.excel</Trans></h4>
						              {progress && !complete && <Progress color="success" value={progress}  />}
						            </StdButton>
						            
					            </UploadField>
					          </div>
				          )}

				        </Uploader>
			        </div>
			        
			        
			      </CardBody>
		      </Card>
		      

		      
		      {downloadable_reports.length > 0 &&  <Card className="no-print">
			      <CardBody>
			        <CardTitle><h2><Trans>companies.sections.download_report</Trans></h2></CardTitle>
			        {downloadable_reports.length > 0 ? downloadable_reports.map((r) =>
                r.refunded==true || r.computed == false ?
                <span className="reporstDownload"  key={r.result_id}>
                  <i className="fas fa-file-pdf" style={{color: 'grey'}}></i><br/>
				          <Trans>products.{r.product.name}</Trans> <br/>
				          <Trans values={{value: r.created_at}}>standard_formatting.date</Trans>
                  {r.refunded==true ? <div>Rimborsato perchè<br/> non disponibile</div> : <div>In aggiornamento</div>}
                </span>
                :
                <Link className="reporstDownload" key={r.result_id} to={`/api/results/${r.result_id}.zip`} target="_blank" download>
				          <i className="fas fa-file-pdf"></i><br/>
				          <Trans>products.{r.product.name}</Trans> <br/>
				          <Trans values={{value: r.created_at}}>standard_formatting.date</Trans>
                </Link>
                
              ) : null}
			      </CardBody>
		      </Card>}

		      
		      {company.reports ? company.reports.filter(r => ['SPEEK_FLASH', 'SPEEK_EXTENDED', 'EXCEL', 'CREDITSAFE', 'CREDITSAFE_WORLD'].includes(r.product.name) ).map((r, index) => <Report key={index} updateReport={updateReport} report={r} />) : null}
		    </div>	
	    )}
	  else
	    return <div></div>
  }
}
export default Companies
